module.exports = __webpack_public_path__ + "static/img/xg1-3.531f4dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xg1-3.png
// module id = 723
// module chunks = 0